// extracted by mini-css-extract-plugin
export var sbShowMain = "link-module--sb-show-main--2VA8D";
export var specialColorLink = "link-module--specialColorLink--2B30N";